module.exports = __webpack_public_path__ + "img/car_icon.0a4fbf8e.png";